import { configureStore } from "@reduxjs/toolkit";
import localeReducer from "../lang/localeSlice";

export default configureStore({
  reducer: {
    locale: localeReducer,
  },
});
